<template>
    <AppLayout>
        <ForgotPasswordForm />
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import ForgotPasswordForm from '@/components/pages/Auth/ForgotPasswordForm.vue';
</script>
